import { forwardRef } from 'react';
import { Box, FlaskConical, LucideProps } from 'lucide-react';

export interface AppIconProps extends LucideProps {
  app?: { sandbox: boolean } | null | undefined;
}

export const AppIcon = forwardRef<SVGSVGElement, AppIconProps>(function AppIcon(
  { app, ...props },
  ref
) {
  const Icon = app?.sandbox ? FlaskConical : Box;
  return <Icon {...props} ref={ref} />;
});
